import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { PROFILE } from "../data/work";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 1.4 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-paper/85 backdrop-blur-md border-b border-line" : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1600px] mx-auto flex items-center justify-between px-5 md:px-12 h-16 md:h-20">
        <Link
          to="/"
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0 })}
          className="font-serif text-xl md:text-2xl tracking-tight text-ink"
        >
          Srishti<span className="text-vermilion">.</span>
        </Link>

        <div className="hidden md:flex items-center gap-9 text-sm font-medium tracking-wide">
          <button data-testid="nav-work" onClick={() => scrollTo("work")} className="link-underline text-ink py-1">
            Work
          </button>
          <button data-testid="nav-about" onClick={() => scrollTo("about")} className="link-underline text-ink py-1">
            About
          </button>
          <button data-testid="nav-contact" onClick={() => scrollTo("contact")} className="link-underline text-ink py-1">
            Contact
          </button>
        </div>

        <div className="flex items-center gap-4 md:gap-6">
          <a
            data-testid="nav-linkedin"
            href={PROFILE.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:inline-flex link-underline text-ink text-sm font-medium tracking-wide py-1"
          >
            LinkedIn
          </a>
          <a
            data-testid="nav-resume"
            href={PROFILE.resumeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 bg-ink text-paper px-4 md:px-5 py-2 md:py-2.5 text-xs md:text-sm font-medium tracking-wide hover:bg-vermilion transition-colors duration-300"
          >
            Résumé
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5">↗</span>
          </a>
        </div>
      </nav>
    </motion.header>
  );
}
